import { Text } from "@chakra-ui/react";

interface ResultsSummaryProps {
  startIndex: number;
  endIndex: number;
  totalItems: number;
  itemType: string;
}

const ResultsSummary = ({ startIndex, endIndex, totalItems, itemType }: ResultsSummaryProps) => {
  if (totalItems === 0) {
    return null;
  }

  return (
    <Text mb={4} fontSize="sm" color="gray.600">
      Showing {startIndex + 1}-{Math.min(endIndex, totalItems)} of {totalItems} {itemType}
    </Text>
  );
};

export default ResultsSummary;
